export default __webpack_public_path__ + "static/media/category.34939c1e.svg";